import { service } from '@ember/service';
import Component from '@glimmer/component';

import { getRecordType } from 'umg-ember-backend/utils/get-record-type';
import { lookupTranslation } from 'umg-ember-backend/utils/intl';

export default class RecordExplorerTableTdTranslateValue extends Component {
  // Services
  @service intl;

  // Getter and setter
  get value() {
    const property = this.args.column.property;
    const value = this.args.record[property];
    const type = getRecordType(this.args.record);
    const lookups = [
      `tables.${type}.options.${property}.${value}`,
      `forms.${type}.options.${property}.${value}`,
      `forms.defaults.options.${property}.${value}`,
    ];

    return lookupTranslation.call(this, lookups);
  }

  // Template
  <template>{{this.value}}</template>
}
